import Axios from "./Axios";

export default class VisitService extends Axios {
  getActiveVisitsByCardNumber() {
    if (localStorage.getItem("consumptionCard") != null) {
      return this.axios.get(
        `/visit/card/${localStorage.getItem("consumptionCard")}`
      );
    }
    return [];
  }

  getActiveVisitsByID() {
    if (localStorage.getItem("visit") != null) {
      return this.axios.get(`/visit/${localStorage.getItem("visit")}/active`);
    }
    return [];
  }

  getHitsRooms(type,room) {
    const accessPoint = JSON.parse(localStorage.getItem("accessPoint"));
    const pdv = accessPoint.configurations[0].pdvs[0];

    let pdvID = "";
    let pdvData = pdv.data || [];
    pdvData.forEach((d) => {
      if (d.key === "app_sistemas_pdv_id") pdvID = d.value;
    });
    if (!pdvID) pdvID = "0";
    let url = `/visit/hits/rooms-by-all-parameters/${pdvID}`
    if (type !== null){
      url += "?type="+type+"&";
    }if (room){
      url += "room="+room;
    }
    return this.axios.get(url);
  }
}
